import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import { invoiceRecipientQueries } from "~/modules/billing/api/invoiceRecipient/invoiceRecipientQueries.ts";
import type { InvoiceRecipient } from "~/modules/billing/api/invoiceRecipient/invoiceRecipientTypes.ts";
import CreateOrUpdateInvoiceRecipientForm
	from "~/modules/client/components/ClientDetailsView/components/ClientsInvoiceRecipientsList/components/CreateOrUpdateInvoiceRecipientForm";

type UpdateInvoiceRecipientSidebarProps = {
	invoiceRecipientData: InvoiceRecipient | null;
	isOpen: boolean;
	onClose: () => void;
};

const UpdateInvoiceRecipientSidebar: FunctionComponent<UpdateInvoiceRecipientSidebarProps> = ({
	invoiceRecipientData,
	isOpen,
	onClose,
}) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		if (!invoiceRecipientData) return;
		await queryClient.refetchQueries({ queryKey: invoiceRecipientQueries.byClient(invoiceRecipientData.clientId).queryKey });
		onClose();
	}, [invoiceRecipientData, onClose, queryClient]);
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			<>
				{!!invoiceRecipientData && <CreateOrUpdateInvoiceRecipientForm
					initialValues={invoiceRecipientData}
					clientId={invoiceRecipientData.clientId}
					onSuccess={handleSuccess}
					onCancelClick={onClose} />}
			</>
		</Sidebar>
	);
};

export default UpdateInvoiceRecipientSidebar;